<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout column>
      <v-autocomplete
        placeholder="Cautare"
        hint="Se cauta dupa simbol si observatii"
        clearable
        persistent-hint
        append-icon="mdi-magnify"
        solo
        :loading="loading"
        single-line
        :suffix="String(total)"
        dense
        return-object
        :items="filteredItems"
        item-text="simbol"
        item-value="_id"
        :search-input.sync="search"
        no-filter
        v-model="selectedItem">
        <template v-slot:selection="data">
          <v-avatar size="16">
            <img :src="getIcon(data.item)">
          </v-avatar>
          &nbsp;
          {{data.item.simbol}}
        </template>
        <template v-slot:item="data">
          <v-list-tile-avatar size="22">
            <img :src="getIcon(data.item)">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="data.item.simbol"></v-list-tile-title>
            <v-list-tile-sub-title>{{data.item.photos.length}} poze</v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>
      <GmapMap
        :center="mapCenter"
        :zoom="zoom"
        :map-type-id="mapType"
        :style="{ width: options.width, height: options.height }"
        ref="map"
        @center_changed="centerChanged"
        @zoom_changed="zoomChanged"
        @maptypeid_changed="mapTypeChanged">

        <GmapMarker
          :position="currentPosition"
          :label="{ text: 'Pozitia ta', color: labelColor, fontWeight: 'bold' }"
          :icon="{ url: '/person.svg', labelOrigin: { x: 36 / 2, y: 64 + 12 } }"
          :draggable="false"/>

        <gmap-cluster :max-zoom="16">
          <GmapMarker
            v-for="(item, index) in items"
            :key="index"
            :position="{lat: Number(item.centru_geometric.lat), lng: Number(item.centru_geometric.lng)}"
            :clickable="true"
            :icon="{
              url: getIcon(item),
              labelOrigin: { x: 24 / 2, y: 24 + 6 },
              size: markerSize,
              scaledSize: markerScale
            }"
            :label="getLabel(item)"
            :draggable="false"
            @click="navigate(item)"
            :animation="user.admin && activeEntity && activeEntity === item._id  ? 1 : null"/>
        </gmap-cluster>
      </GmapMap>
    </v-layout>
  </v-container>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'
// import isEqual from 'lodash.isequal'

export default {
  name: 'entity-map',
  props: {
    entity: {
      type: String,
      required: false
    }
  },
  computed: {
    google: gmapApi,
    currentPosition () {
      return this.$store.getters.currentPosition
    },
    loading () {
      return this.$store.getters.loading
    },
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    zoom () {
      return this.$store.getters.zoom
    },
    mapType () {
      return this.$store.getters.mapType
    },
    total () {
      return this.filteredItems.length
    },
    activeEntity () {
      return this.$route.params.entity
    },
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    google: {
      immediate: true,
      handler (g) {
        if (g) {
          this.markerSize = new g.maps.Size(48, 48)
          this.markerScale = new g.maps.Size(24, 24)
        }
      }
    },
    selectedItem (v) {
      if (v) {
        this.$refs.map.$mapPromise.then((map) => {
          map.panTo({ lat: Number(v.centru_geometric.lat), lng: Number(v.centru_geometric.lng) })
          map.setZoom(19)
        })
      }
    },
    search: {
      immediate: false,
      handler: debounce(function (v) {
        this.queryItems(v)
      }, 1000)
    }
  },
  data: () => ({
    search: null,
    options: {
      width: '100%',
      height: '100%'
    },
    items: [],
    filteredItems: [],
    labelColor: 'white',
    markerSize: null,
    markerScale: null,
    selectedItem: null
  }),
  methods: {
    queryItems (search) {
      this.filteredItems = search ? this.items.filter(item => this.filter(item, search, item.simbol)) : this.items
    },
    filter (item, search, value) {
      return value ? value.toLowerCase().includes(search.toLowerCase()) : false
    },
    centerChanged: debounce(function ($event) {
      const mapCenter = { lat: $event.lat(), lng: $event.lng() }
      this.$store.commit('setMapCenter', mapCenter)
    }, 1000),
    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoom', $event)
    }, 1000),
    mapTypeChanged ($event) {
      if ($event === 'roadmap' || $event === 'terrain') this.labelColor = 'black'
      else this.labelColor = 'white'
      this.$store.commit('setMapType', $event)
    },
    getIcon (marker) {
      switch (marker.sheet) {
        case 'eligibile ': return marker.done ? '/svg/eligibile/square_done.svg' : '/svg/eligibile/square.svg'
        case 'partial eligibile ': return marker.done ? '/svg/partial_eligibile/circle_done.svg' : '/svg/partial_eligibile/circle.svg'
        case 'Partial&Posibil Eligibile': return marker.done ? '/svg/partial_posibil_eligibile/pentagon_done.svg' : '/svg/partial_posibil_eligibile/pentagon.svg'
        case 'posibil eligibile': return marker.done ? '/svg/posibil_eligibile/diamond_done.svg' : '/svg/posibil_eligibile/diamond.svg'
      }
    },
    getLabel (marker) {
      return { text: String(`${marker.simbol} (${marker.photos.length})`), color: this.labelColor, fontWeight: 'bold' }
    },
    navigate (marker) {
      this.$router.push({ name: 'details', params: { entity: marker._id } })
    }
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('entities/fetchAllEntities')
      .then(items => {
        this.$store.commit('setLoading', false)
        this.items = items
        this.filteredItems = items
      })
      .catch(err => {
        this.$store.commit('setLoading', false)
        console.log(err)
      })
  }
}
</script>

<style>

</style>
